type RefineResponse =
  | string
  | {
      refined_text?: string;
      result?: string;
      response?: string;
    }
  | null
  | undefined;

export const extractRefinedText = (data: RefineResponse): string | null => {
  if (!data) return null;
  if (typeof data === "string") return data;
  if (data.refined_text) return data.refined_text;
  if (data.result) return data.result;
  if (data.response) return data.response;
  return null;
};
